// import { useEffect } from 'react';

import io from "socket.io-client";

// export const Socket = () => {
export const socket = io(`${process.env.REACT_APP_SOCKET_BASE_URL}`,
    {
        path: `${process.env.REACT_APP_SOCKET_PATH}`
    }
);
// Event listener for successful connection

// Listen for messages from the server
// console.log("socket", socket, JSON.parse(sessionStorage.getItem("__takk_out")).id);
// socket.on('connect', (socket) => {
//     // Update order status based on the received data

//     socket.connect("userOnline", JSON.parse(localStorage.getItem("__takk_out")).id);
// });
// // Clean up the socket connection when the component is unmounted
// console.log("socket", socket);
// return () => {
//     socket.disconnect();
// };

// }

// export const Socket = () => {
//     const socket = io('https://boomerangeatsapp.com', { path: '/socket/io' });

//     //Listen for messages from the server

//     socket.on('connection', (socket) => {
//         //Update Order status based on the received data
//         console.log('A User connected');

//     })
// }


